import { FontSizeToken } from '@weenat/theme'

export const elementIds = {
  OverlayContainer: 'OverlayContainer',
  ListHeader: 'ListHeader'
}

export const MAP_ICON_SIZE: FontSizeToken = '2xl'
